<template>
	<div id="app" class="h-100">
		<notifications group="foo" :ignoreDuplicates="true" :position="'top right'"/>
		<div class="captail_wrap" :class="( $route.path == '/individual-step3-doc' )? 'p-0' : ''" v-if="$route.path == '/individual-step3-doc'">
			<notifications group="notification" :ignoreDuplicates="true" :position="'top right'"/>
			<div class="sessionexpriedouter" v-if="walletSessionTimeOut">
				<div class="cbox">
					<div class="mb-0">
						<img src="../static/website/images/sessiionOut.svg" alt="session expired" width="170">
					</div>
					<p class="my-3">Your session has expired. Please login again</p>
					<a role="menuitem" class="cap_btn" tabindex="-1" href="#" @click.prevent="logout()">ok</a>
				</div>
			</div> 
			<router-view />
		</div>
		<router-view v-else />
	</div>
</template>

<script>
	import $ from 'jquery'
	import tradingMixins from '@/plugins/trading';
	import { supportMixins } from '@/plugins/support'
	//import '../static/website/js/jquery.min.js';
	import '../static/website/js/popper.min.js';
	import '../static/website/js/bootstrap.min.js';
	import '../static/website/js/jquery.overlayScrollbars.min.js';
	//import '../static/website/js/feather.min.js';
	// import '../static/website/js/awselect.js';
	import '../static/website/js/jquery.dataTables.min.js';
	import '../static/website/js/custom.js';
	import '../static/website/js/jquery-image-blob.min.js';
	import * as types from '@/types'
	import { mapActions } from 'vuex'
	export default {
		name: 'App',
		data() {
			return {
				walletSessionTimeOut: false
			}
		},
		mixins: [
			supportMixins,
			tradingMixins
		],
		updated() {
			// window.scroll(0,0)

		},
		methods:{
			...mapActions({
				_runstateLoad: types.RUN_STATE_LOAD,
				_runLogout: types.RUN_LOGOUT
			}),
			logout(){
				let input_json={
					'globalParams' :{},
					'localParams' :{ "parameter" : this }
				}
				this._runLogout(input_json)
			},
			orderlisting(){
				if(this.tradingAccount.length > 0){
					let jsonData = { 
						'globalParams' :{
							'account_id' : this.tradingAccount[0].account_id,
							'demo_live' : this.tradingAccount[0].demo_live
						},
						'localParams' :{"parameter" : this}
					}
					this._runGetOrderList(jsonData)
				}
	        }
		},
		created(){
		console.log('new change')
			if(this.$route.path == '/individual-step3-doc'){
				this._runstateLoad({'globalParams' :{},'localParams' :{ "parameter" : this }})
				this._runTradingAccount({ 'globalParams' :{ },'localParams' :{"parameter" : this,'page':'home'}})
				this._runGetNotificationList({ 'globalParams' :{read : 0}, 'localParams' :{ "parameter" : this } })
				// =========Call from supportMixins==============
				this._runGetTicketReasonList({ 'globalParams' :{},'localParams' :{"parameter" : this}})
			}
		}
	}
</script>

<style>
@import '../static/website/css/fonts.css';
@import '../static/website/css/bootstrap.min.css';
/*@import '../static/website/css/font-awesome.min.css';*/
@import '../static/website/css/OverlayScrollbars.min.css';
/* @import '../static/website/css/scrolling-nav.css'; */
@import '../static/website/css/jquery.dataTables.min.css';
@import '../static/website/css/style.css';
@import '../static/website/css/responsive.css';
@import 'vue-select/dist/vue-select.css';
@import 'vue-slick-carousel/dist/vue-slick-carousel.css';
@import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
@import "../static/website/css/stx-standard.css";
@import "../static/website/css/stx-chart.css";
/*@import "../static/website/css/font-awesome.css";*/

</style>



// WEBPACK FOOTER //
// src/App.vue